// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-b312d183] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.input-field[data-v-b312d183] {
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-large);
  margin-block-start: 6px;
}
.input-field__main-wrapper[data-v-b312d183] {
  height: var(--default-clickable-area);
  position: relative;
}
.input-field--disabled[data-v-b312d183] {
  opacity: .4;
  filter: saturate(.4);
}
.input-field__input[data-v-b312d183] {
  margin: 0;
  padding-inline: 12px 6px;
  height: var(--default-clickable-area) !important;
  width: 100%;
  font-size: var(--default-font-size);
  text-overflow: ellipsis;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  border: 2px solid var(--color-border-maxcontrast);
  border-radius: var(--border-radius-large);
  cursor: pointer;
  -webkit-appearance: textfield !important;
  -moz-appearance: textfield !important;
}
.input-field__input--label-outside[data-v-b312d183] {
  padding-block: 0;
}
.input-field__input[data-v-b312d183]:active:not([disabled]),
.input-field__input[data-v-b312d183]:hover:not([disabled]),
.input-field__input[data-v-b312d183]:focus:not([disabled]) {
  border-color: 2px solid var(--color-main-text) !important;
  box-shadow: 0 0 0 2px var(--color-main-background) !important;
}
.input-field__input:focus + .input-field__label[data-v-b312d183],
.input-field__input:hover:not(:placeholder-shown) + .input-field__label[data-v-b312d183] {
  color: var(--color-main-text);
}
.input-field__input[data-v-b312d183]:not(:focus, .input-field__input--label-outside)::placeholder {
  opacity: 0;
}
.input-field__input[data-v-b312d183]:focus {
  cursor: text;
}
.input-field__input[data-v-b312d183]:disabled {
  cursor: default;
}
.input-field__input[data-v-b312d183]:focus-visible {
  box-shadow: unset !important;
}
.input-field__input--leading-icon[data-v-b312d183] {
  padding-inline-start: var(--default-clickable-area);
}
.input-field__input--trailing-icon[data-v-b312d183] {
  padding-inline-end: var(--default-clickable-area);
}
.input-field__input--success[data-v-b312d183] {
  border-color: var(--color-success) !important;
}
.input-field__input--success[data-v-b312d183]:focus-visible {
  box-shadow:
    #f8fafc 0 0 0 2px,
    var(--color-primary-element) 0 0 0 4px,
    #0000000d 0 1px 2px;
}
.input-field__input--error[data-v-b312d183] {
  border-color: var(--color-error) !important;
}
.input-field__input--error[data-v-b312d183]:focus-visible {
  box-shadow:
    #f8fafc 0 0 0 2px,
    var(--color-primary-element) 0 0 0 4px,
    #0000000d 0 1px 2px;
}
.input-field__input--pill[data-v-b312d183] {
  border-radius: var(--border-radius-pill);
}
.input-field__label[data-v-b312d183] {
  position: absolute;
  margin-inline: 14px 0;
  max-width: fit-content;
  inset-block-start: 11px;
  inset-inline: 0;
  color: var(--color-text-maxcontrast);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  transition:
    height var(--animation-quick),
    inset-block-start var(--animation-quick),
    font-size var(--animation-quick),
    color var(--animation-quick),
    background-color var(--animation-quick) var(--animation-slow);
}
.input-field__label--leading-icon[data-v-b312d183] {
  margin-inline-start: var(--default-clickable-area);
}
.input-field__label--trailing-icon[data-v-b312d183] {
  margin-inline-end: var(--default-clickable-area);
}
.input-field__input:focus + .input-field__label[data-v-b312d183],
.input-field__input:not(:placeholder-shown) + .input-field__label[data-v-b312d183] {
  inset-block-start: -10px;
  line-height: 1.5;
  font-size: 13px;
  font-weight: 500;
  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0;
  background-color: var(--color-main-background);
  padding-inline: 5px;
  margin-inline-start: 9px;
  transition:
    height var(--animation-quick),
    inset-block-start var(--animation-quick),
    font-size var(--animation-quick),
    color var(--animation-quick);
}
.input-field__input:focus + .input-field__label--leading-icon[data-v-b312d183],
.input-field__input:not(:placeholder-shown) + .input-field__label--leading-icon[data-v-b312d183] {
  margin-inline-start: 41px;
}
.input-field__icon[data-v-b312d183] {
  position: absolute;
  height: var(--default-clickable-area);
  width: var(--default-clickable-area);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: .7;
}
.input-field__icon--leading[data-v-b312d183] {
  inset-block-end: 0;
  inset-inline-start: 2px;
}
.input-field__icon--trailing[data-v-b312d183] {
  inset-block-end: 0;
  inset-inline-end: 2px;
}
.input-field__trailing-button.button-vue[data-v-b312d183] {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: var(--border-radius-large);
}
.input-field__trailing-button--pill.button-vue[data-v-b312d183] {
  border-radius: var(--border-radius-pill);
}
.input-field__helper-text-message[data-v-b312d183] {
  padding-block: 4px;
  display: flex;
  align-items: center;
}
.input-field__helper-text-message__icon[data-v-b312d183] {
  margin-inline-end: 8px;
}
.input-field__helper-text-message--error[data-v-b312d183] {
  color: var(--color-error-text);
}
.input-field__helper-text-message--success[data-v-b312d183] {
  color: var(--color-success-text);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcInputField-L2Lld_iG.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,gDAAgD;EAChD,WAAW;EACX,mCAAmC;EACnC,uBAAuB;EACvB,8CAA8C;EAC9C,6BAA6B;EAC7B,iDAAiD;EACjD,yCAAyC;EACzC,eAAe;EACf,wCAAwC;EACxC,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,yDAAyD;EACzD,6DAA6D;AAC/D;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mDAAmD;AACrD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE;;;uBAGqB;AACvB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE;;;uBAGqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB;;;;;iEAK+D;AACjE;AACA;EACE,kDAAkD;AACpD;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4EAA4E;EAC5E,8CAA8C;EAC9C,mBAAmB;EACnB,wBAAwB;EACxB;;;;gCAI8B;AAChC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-b312d183] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.input-field[data-v-b312d183] {\n  position: relative;\n  width: 100%;\n  border-radius: var(--border-radius-large);\n  margin-block-start: 6px;\n}\n.input-field__main-wrapper[data-v-b312d183] {\n  height: var(--default-clickable-area);\n  position: relative;\n}\n.input-field--disabled[data-v-b312d183] {\n  opacity: .4;\n  filter: saturate(.4);\n}\n.input-field__input[data-v-b312d183] {\n  margin: 0;\n  padding-inline: 12px 6px;\n  height: var(--default-clickable-area) !important;\n  width: 100%;\n  font-size: var(--default-font-size);\n  text-overflow: ellipsis;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  border: 2px solid var(--color-border-maxcontrast);\n  border-radius: var(--border-radius-large);\n  cursor: pointer;\n  -webkit-appearance: textfield !important;\n  -moz-appearance: textfield !important;\n}\n.input-field__input--label-outside[data-v-b312d183] {\n  padding-block: 0;\n}\n.input-field__input[data-v-b312d183]:active:not([disabled]),\n.input-field__input[data-v-b312d183]:hover:not([disabled]),\n.input-field__input[data-v-b312d183]:focus:not([disabled]) {\n  border-color: 2px solid var(--color-main-text) !important;\n  box-shadow: 0 0 0 2px var(--color-main-background) !important;\n}\n.input-field__input:focus + .input-field__label[data-v-b312d183],\n.input-field__input:hover:not(:placeholder-shown) + .input-field__label[data-v-b312d183] {\n  color: var(--color-main-text);\n}\n.input-field__input[data-v-b312d183]:not(:focus, .input-field__input--label-outside)::placeholder {\n  opacity: 0;\n}\n.input-field__input[data-v-b312d183]:focus {\n  cursor: text;\n}\n.input-field__input[data-v-b312d183]:disabled {\n  cursor: default;\n}\n.input-field__input[data-v-b312d183]:focus-visible {\n  box-shadow: unset !important;\n}\n.input-field__input--leading-icon[data-v-b312d183] {\n  padding-inline-start: var(--default-clickable-area);\n}\n.input-field__input--trailing-icon[data-v-b312d183] {\n  padding-inline-end: var(--default-clickable-area);\n}\n.input-field__input--success[data-v-b312d183] {\n  border-color: var(--color-success) !important;\n}\n.input-field__input--success[data-v-b312d183]:focus-visible {\n  box-shadow:\n    #f8fafc 0 0 0 2px,\n    var(--color-primary-element) 0 0 0 4px,\n    #0000000d 0 1px 2px;\n}\n.input-field__input--error[data-v-b312d183] {\n  border-color: var(--color-error) !important;\n}\n.input-field__input--error[data-v-b312d183]:focus-visible {\n  box-shadow:\n    #f8fafc 0 0 0 2px,\n    var(--color-primary-element) 0 0 0 4px,\n    #0000000d 0 1px 2px;\n}\n.input-field__input--pill[data-v-b312d183] {\n  border-radius: var(--border-radius-pill);\n}\n.input-field__label[data-v-b312d183] {\n  position: absolute;\n  margin-inline: 14px 0;\n  max-width: fit-content;\n  inset-block-start: 11px;\n  inset-inline: 0;\n  color: var(--color-text-maxcontrast);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transition:\n    height var(--animation-quick),\n    inset-block-start var(--animation-quick),\n    font-size var(--animation-quick),\n    color var(--animation-quick),\n    background-color var(--animation-quick) var(--animation-slow);\n}\n.input-field__label--leading-icon[data-v-b312d183] {\n  margin-inline-start: var(--default-clickable-area);\n}\n.input-field__label--trailing-icon[data-v-b312d183] {\n  margin-inline-end: var(--default-clickable-area);\n}\n.input-field__input:focus + .input-field__label[data-v-b312d183],\n.input-field__input:not(:placeholder-shown) + .input-field__label[data-v-b312d183] {\n  inset-block-start: -10px;\n  line-height: 1.5;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0;\n  background-color: var(--color-main-background);\n  padding-inline: 5px;\n  margin-inline-start: 9px;\n  transition:\n    height var(--animation-quick),\n    inset-block-start var(--animation-quick),\n    font-size var(--animation-quick),\n    color var(--animation-quick);\n}\n.input-field__input:focus + .input-field__label--leading-icon[data-v-b312d183],\n.input-field__input:not(:placeholder-shown) + .input-field__label--leading-icon[data-v-b312d183] {\n  margin-inline-start: 41px;\n}\n.input-field__icon[data-v-b312d183] {\n  position: absolute;\n  height: var(--default-clickable-area);\n  width: var(--default-clickable-area);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: .7;\n}\n.input-field__icon--leading[data-v-b312d183] {\n  inset-block-end: 0;\n  inset-inline-start: 2px;\n}\n.input-field__icon--trailing[data-v-b312d183] {\n  inset-block-end: 0;\n  inset-inline-end: 2px;\n}\n.input-field__trailing-button.button-vue[data-v-b312d183] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-radius: var(--border-radius-large);\n}\n.input-field__trailing-button--pill.button-vue[data-v-b312d183] {\n  border-radius: var(--border-radius-pill);\n}\n.input-field__helper-text-message[data-v-b312d183] {\n  padding-block: 4px;\n  display: flex;\n  align-items: center;\n}\n.input-field__helper-text-message__icon[data-v-b312d183] {\n  margin-inline-end: 8px;\n}\n.input-field__helper-text-message--error[data-v-b312d183] {\n  color: var(--color-error-text);\n}\n.input-field__helper-text-message--success[data-v-b312d183] {\n  color: var(--color-success-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
